import { createSelector } from '@reduxjs/toolkit';
import { selectBuildingLiftTypesType } from 'shared/selectors/jsonQuery';
import { EBuildingElevatorType } from '../../../../packages/api-models/common/json_query';

const OPTIONS = [
  { label: 'Пассажирский', value: EBuildingElevatorType.Passenger },
  { label: 'Грузовой', value: EBuildingElevatorType.Service },
  { label: 'Тельфер', value: EBuildingElevatorType.Telpher },
];

export const selectBuildingLiftTypesTypeFilter = createSelector(selectBuildingLiftTypesType, value => ({
  label: 'Лифт',
  options: OPTIONS,
  value: value && value.length > 0 ? value : [null],
}));
